import { ServiceCatalog } from "./ServiceCatalog.js";
export const LEAD_BUSINESS_TYPE_OPTIONS = [
    { value: "", label: "Select one" },
    { value: "restaurant", label: "Restaurant / food service" },
    { value: "dealership", label: "Dealership / automotive" },
    { value: "other", label: "Other" },
];
export const LEAD_INTAKE_SERVICE_OPTIONS = [
    ...ServiceCatalog.services.map((s) => ({ value: s.key, label: s.name })),
    { value: "not_sure", label: "Not sure yet" },
];
const BUSINESS_LABEL = {
    restaurant: "Restaurant / food service",
    dealership: "Dealership / automotive",
    other: "Other",
};
/** Structured projectDescription block for full-page Get started intake (#620 / #656). */
export function formatLeadIntakeDescription(input) {
    const parts = [];
    const contact = input.contactName.trim();
    if (contact)
        parts.push(`Contact: ${contact}`);
    if (input.businessType) {
        parts.push(`Business type: ${BUSINESS_LABEL[input.businessType]}`);
    }
    const site = input.existingWebsite?.trim();
    if (site)
        parts.push(`Existing website: ${site}`);
    if (input.addons && input.addons.length > 0) {
        parts.push(`Add-ons: ${input.addons.join(", ")}`);
    }
    const notes = input.notes.trim();
    if (notes)
        parts.push(`Notes:\n${notes}`);
    const prefill = input.prefillBlock?.trim();
    if (prefill)
        parts.push(prefill);
    return parts.join("\n\n");
}
//# sourceMappingURL=leadIntake.js.map